import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ModalRef, ModalV2Component, ModalModule, ButtonV2Module } from '@schenck/rotec-components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'rm-session-expired-modal',
  templateUrl: './session-expired-modal.component.html',
  styleUrls: ['./session-expired-modal.component.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [ModalModule, ButtonV2Module, TranslatePipe],
})
export class SessionExpiredModalComponent {
  public modalRef = inject<ModalRef<number>>(ModalRef);

  public width: string = '500px';

  @ViewChild(ModalV2Component, { static: true }) modalContainer: ModalV2Component;

  public logIn(): void {
    this.modalRef.close();
    window.location.reload();
  }
}
